module.exports = __webpack_public_path__ + "img/democraticrepublicofthecongo.9b5b0dfb.svg";